// extracted by mini-css-extract-plugin
export default {"map__container":"SchoolProfileMap_map__container__iAsY9"};